import React from 'react';
import { TrendingUp, Security, AccessTime, Support } from '@mui/icons-material';

const StatsSection = () => {
    const stats = [
        {
            value: '99.9%',
            label: 'Disponibilité',
            description: 'Taux de disponibilité garanti',
            icon: TrendingUp,
            color: 'from-emerald-400 to-green-500',
            delay: '0ms'
        },
        {
            value: '24/7',
            label: 'Support technique',
            description: 'Assistance prioritaire en continu',
            icon: Support,
            color: 'from-amber-400 to-yellow-500',
            delay: '200ms'
        },
        {
            value: '<5min',
            label: 'Intégration',
            description: 'Premier paiement en moins de 5min',
            icon: AccessTime,
            color: 'from-orange-400 to-amber-500',
            delay: '400ms'
        },
        {
            value: 'PCI DSS',
            label: 'Niveau 1',
            description: 'Certification sécurité maximale',
            icon: Security,
            color: 'from-red-400 to-orange-500',
            delay: '600ms'
        }
    ];

    return (
        <section className="relative py-20 bg-gradient-to-br from-amber-600 via-orange-600 to-yellow-600 overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-10">
                <div className="absolute inset-0" style={{
                    backgroundImage: `radial-gradient(circle at 25% 25%, #ffffff 2px, transparent 2px)`,
                    backgroundSize: '50px 50px'
                }}></div>
            </div>

            {/* Animated Background Elements */}
            <div className="absolute top-0 left-0 w-64 h-64 bg-amber-300/20 rounded-full blur-3xl animate-float"></div>
            <div className="absolute bottom-0 right-0 w-80 h-80 bg-orange-300/20 rounded-full blur-3xl animate-float animation-delay-2000"></div>
            <div className="absolute top-1/2 left-1/4 w-48 h-48 bg-yellow-300/15 rounded-full blur-2xl animate-float animation-delay-4000"></div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                {/* Section Header */}
                <div className="text-center mb-16">
                    <div className="inline-flex items-center px-6 py-3 rounded-full bg-white/10 backdrop-blur-md border border-white/20 mb-6">
                        <span className="w-3 h-3 bg-emerald-400 rounded-full mr-3 animate-pulse"></span>
                        <span className="text-white/90 font-semibold text-lg">CHIFFRES CLÉS</span>
                    </div>
                    <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
                        Des performances{' '}
                        <span className="bg-gradient-to-r from-amber-200 to-yellow-200 bg-clip-text text-transparent">
                            d'exception
                        </span>
                    </h2>
                    <p className="text-xl text-white/80 max-w-3xl mx-auto leading-relaxed">
                        Notre infrastructure est conçue pour offrir la meilleure expérience
                        de paiement avec une disponibilité maximale et une sécurité absolue.
                    </p>
                </div>

                {/* Stats Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {stats.map((stat, index) => (
                        <div
                            key={index}
                            className="group relative bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20 hover:border-white/40 transition-all duration-500 hover:-translate-y-2"
                            style={{ animationDelay: stat.delay }}
                        >
                            {/* Hover Effect */}
                            <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                            {/* Icon Container */}
                            <div className="relative z-10">
                                <div className={`bg-gradient-to-r ${stat.color} w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                                    <stat.icon className="text-2xl text-white" />
                                </div>

                                {/* Main Value */}
                                <div className="text-4xl lg:text-5xl font-bold text-white mb-2 group-hover:scale-105 transition-transform duration-300">
                                    {stat.value}
                                </div>

                                {/* Label */}
                                <div className="text-lg font-semibold text-amber-100 mb-2">
                                    {stat.label}
                                </div>

                                {/* Description */}
                                <div className="text-white/70 text-sm leading-relaxed">
                                    {stat.description}
                                </div>
                            </div>

                            {/* Shine Effect on Hover */}
                            <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
                        </div>
                    ))}
                </div>

                {/* Bottom Trust Badges */}
                <div className="text-center mt-16">
                    <div className="inline-flex flex-wrap justify-center gap-8 items-center bg-white/5 backdrop-blur-md rounded-2xl px-8 py-6 border border-white/10">
                        <div className="flex items-center space-x-3 text-white/80">
                            <div className="w-3 h-3 bg-emerald-400 rounded-full animate-pulse"></div>
                            <span className="font-medium">+10 000 développeurs</span>
                        </div>
                        <div className="flex items-center space-x-3 text-white/80">
                            <div className="w-3 h-3 bg-amber-400 rounded-full animate-pulse"></div>
                            <span className="font-medium">+50M transactions/mois</span>
                        </div>
                        <div className="flex items-center space-x-3 text-white/80">
                            <div className="w-3 h-3 bg-orange-400 rounded-full animate-pulse"></div>
                            <span className="font-medium">99.99% satisfaction</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default StatsSection;